import Cookies from 'lib/Cookies';

export function trimWhitespaceOnStrings(field: any) {
  if (typeof field === 'string' || field instanceof String) {
    return field.trim();
  }
  return field;
};

export function conditionallyAddPlus(number?: string) {
  if (number && number.length > 0 && !number.startsWith('+')) {
    return '+' + number;
  } else {
    return number;
  }
}

export function getMarketingExperimentFields(): {
  experiment?: string,
  experimentVariant?: string,
} {
  const experimentVariant = Cookies.get('marketing_experiment_variant');
  if (experimentVariant) {
    return {
      experiment: '2018.oct.web.cms_backed_marketing_site',
      experimentVariant,
    };
  }

  return {};
}

export function priceInCents(price: string) {
  return parseFloat(price.replace(/[,$.]/g, ''));
}
